import { Spinner100 } from "../icons/SvgIcons";

const variantStyles = {
  primary: [
    "bg-[#0477AD] text-white",
    "hover:bg-[#036a9a]",
    "focus-visible:ring-[#0477AD]/50",
  ].join(" "),
  secondary: [
    "bg-white border border-[#0477AD] text-[#0477AD]",
    "hover:bg-[#f0f7fc]",
    "focus-visible:ring-[#0477AD]/30",
  ].join(" "),
};

const sizeStyles = {
  lg: "h-[50px] px-[18px] py-[13px] text-base",
  md: "px-4 py-2 text-sm",
  sm: "px-4 py-2 text-xs",
  xs: "px-2 py-1 text-sm",
};

const disabledStyle = "bg-gray-400 text-white border-gray-400 cursor-not-allowed hover:bg-gray-400";

function Button({
  variant = "primary",
  size = "md",
  fullWidth = false,
  loading = false,
  disabled = false,
  icon = null,
  iconPosition = "left",
  className = "",
  children,
  ...props
}) {
  const isDisabled = disabled || loading;

  const classes = [
    "inline-flex items-center justify-center gap-[6px] rounded-lg font-inter font-semibold transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2",
    variantStyles[variant] || variantStyles.primary,
    sizeStyles[size] || sizeStyles.md,
    fullWidth ? "w-full" : "",
    disabled && !loading ? disabledStyle : "",
    loading ? "cursor-wait" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button className={classes} disabled={isDisabled} {...props}>
      {loading ? (
        <Spinner100 className="w-6 h-6 animate-spin text-[#0477ad] fill-white" />
      ) : (
        <>
          {icon && iconPosition === "left" && icon}
          {children && <span>{children}</span>}
          {icon && iconPosition === "right" && icon}
        </>
      )}
    </button>
  );
}

export default Button;
